import { applyMiddleware, compose, createStore } from 'redux';

import composeWithDevTools from './composeWithDevTools';
import createForwardActionsMiddleware from './createForwardActionsMiddleware';
import reducer from './reducer';

const state = initState => {
  const reduxDevToolsEnabled =
    process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test';
  const initialState = initState || {
    root: null,
    components: {},
    componentsProperties: {},
  };
  const composeWith = reduxDevToolsEnabled ? composeWithDevTools() : compose;

  return createStore(
    reducer,
    initialState,
    composeWith(
      applyMiddleware(
        createForwardActionsMiddleware({
          match: action => action.type.startsWith('VIEW_'),
        })
      )
    )
  );
};

export default state;
